import React, { useState, useEffect } from 'react';
import { Layout, Row, Col, Form, notification,Input, Button, Checkbox, Select } from 'antd';
import { UserOutlined, LockOutlined } from '@ant-design/icons';
import { useHistory } from "react-router-dom";
import useWindowDimensions from '../../hooks/windowDimensionsHook'
import backgroundImg from './background.jpg';
import backgroundImgMed from './backgroundmed.jpg';
import logoevConnect from '../../imagens/evconnectb.png';
import logo from '../../imagens/logo.png';
import apicheckout from '../../api/apicheckout';
import AsyncStorage from '@react-native-async-storage/async-storage';
import { connect } from 'react-redux'

const { Content } = Layout;
const { Option } = Select;


const tailLayout = {
  wrapperCol: { span: 16 },
};

const msgErrorLogin = () => {
  notification['error']({
      message: 'Falha na autenticação',
      description:
          'Usuário não localizado',
  });
};

function App ({ usuario, asyncLogin, definirUsuario }) {
  let history = useHistory();
  const [bg, setBackGround] = useState(backgroundImg);
  const [loading, setLoading] = useState(false);
  const {height, width } = useWindowDimensions();
  const [LoginEPrescription, setLoginEPrescription] = useState(false);
  const [login, setLogin] = useState('');
  const [senha, setSenha] = useState('');
  const [baseOperacional, setBaseOperacional] = useState('');

  const storeData = async (value) => {
    try {
      const jsonValue = JSON.stringify(value);
      console.log('Gravando usuario:', jsonValue)
      await AsyncStorage.setItem('user', jsonValue)
    } catch (e) {
    }
  }
  
  function ePrescriptionModo() {
    setBackGround(backgroundImgMed);
    setLoginEPrescription(true);
  }

  const getUser = async () => {
    try {
      const jsonValue = await AsyncStorage.getItem('user');
      console.log('Verificando se existe usuario' , jsonValue)
      if (jsonValue != null) {
        const user = JSON.parse(jsonValue);
        definirUsuario(user);
        if(user.perfil === 'Admin')
          history.push({
            pathname: '/dashboard',
            state: { detail: user }
          });
        else {
          history.push({
            pathname: '/nfs',
            state: { detail: user }
          });
        }  
      } 
    } catch(e) {
    }
  }

  useEffect(() => getUser(),[]);

  useEffect(() => {
    console.log('useEffect usuario:', usuario);
      if(usuario === undefined) {
        return;
      } else {
      if(usuario.id !== 0){
        console.log('USUARIO ENCONTRADO', usuario);
        if(LoginEPrescription === true) {
          history.push({
            pathname: '/eprescription',
            state: { detail: usuario }
          });
          return;
        }
        history.push({
          pathname: '/termos',
          state: { detail: usuario }
        });
      } else {
        console.log('Usuario não localizado =>', usuario)
        msgErrorLogin();
      }
    }  
  }, [usuario]);


  async function Login(){
    setLoading(true);
    const usuarioForm = {
      login: login,
      senha: senha,
      baseOperacional: baseOperacional
    }
    await asyncLogin(usuarioForm);
    setLoading(false);
  }

  // const onFinish = async (values) => {
  //   setLoading(true);

  //   const auth = {
  //     login: values.username,
  //     senha: values.password,
  //     baseOperacional: values.baseoperacional
  //   }
    
  //   console.log('Success:', values);
  //   apicheckout.post('Autenticacao/Logar', auth, {
  //     headers: { 'Content-Type': 'application/json' }
  //   }).then(function (response) {
  //     console.log('/Autenticacao/Logar [SUCESSO]:', response);
      
  //     setLoading(false);
  //     storeData(response.data)
  //     if(LoginEPrescription === true) {
  //       history.push({
  //         pathname: '/eprescription',
  //         state: { detail: response.data }
  //       });
  //       return;
  //     }
  //     history.push({
  //       pathname: '/termos',
  //       state: { detail: response.data }
  //     });
  //   }).catch(function (error) {
  //     console.log('/Autenticacao/Logar [ERROR]:', error);
  //     msgErrorLogin();
  //     setLoading(false);
  //   });
  // };

  const onFinishFailed = errorInfo => {
    console.log('Failed:', errorInfo);
  };
  return (
    <Content>
      <Row style={{ height: height }}>
        {
          width > 600 ? (
            <Col style={{ height: height, backgroundImage: 'url(' + bg + ')', backgroundSize: "cover", }} xs={24} sm={24} md={16} lg={16} xl={16}>
              <Row style={{ padding: 20, marginTop: height / 2 - 250 }}>
                <Col span={4}></Col>
                <Col span={16}><img src={logoevConnect} /> </Col>
                <Col span={4}></Col>
              </Row>
            </Col>

          ) : null
        }
        <Col style={{ height: height }} xs={24} sm={24} md={8} lg={8} xl={8} style={{
          backgroundColor: '#eee',
        }}>

          <Form
            style={{ padding: 20, marginTop: height / 2 - 200 }}
            name="basic"
            layout='vertical'
            initialValues={{ remember: true }}>
            <Row>
              <Col span={4}></Col>
              <Col span={16}>
                <img width={220} src={logo} />
              </Col>
              <Col span={4}></Col>
            </Row>
            {
              width < 600 ? (
                <>
                  <Row>
                    <Col span={4}></Col>
                    <Col span={16} style={{ alignItems: 'center', alignContent: 'center' }}>
                      <img width={140} style={{ margin: 10, alignSelf: 'center' }} src={logoevConnect} />
                    </Col>
                    <Col span={4}></Col>
                  </Row>

                </>
              ) : null
            }
            <Form.Item
              label="Usuário:"
              name="username"
              onChange={(e) => setLogin(e.target.value)}
              rules={[{ required: true, message: 'Por favor informe o usuario!' }]} >
              <Input size="large" placeholder="Codigo" prefix={<UserOutlined />} />
            </Form.Item>

            <Form.Item
              label="Senha"
              name="password"
              onChange={(e) => setSenha(e.target.value)}
              rules={[{ required: true, message: 'Por favor informe a senha!' }]}
            >
              <Input.Password size="large" placeholder="Senha" prefix={<LockOutlined />} />
            </Form.Item>

            <Form.Item
              label="Base Operacional:"
              name="baseoperacional"
              
              rules={[{ required: true, message: 'Por favor informe o local!' }]}
            >
              <Select onChange={(e) => setBaseOperacional(e)} style={{ width: '100%' }} defaultValue="CE">
                <Option value="0">Selecione</Option>
                <Option value="CE">CE</Option>
                <Option value="SP">SP</Option>
              </Select>
            </Form.Item>
            <Form.Item {...tailLayout} name="remember" valuePropName="checked">
              <Checkbox>Lembrar</Checkbox>
            </Form.Item>

            <Form.Item {...tailLayout} style={{ alignItems: 'center' }}>
              <Button block loading={loading} onClick={Login} shape="round" style={{ width: 200, color:'#fff', backgroundColor: '#114873', borderColor: '#114873' }} >
                Login
                </Button>
            </Form.Item>
            <Form.Item {...tailLayout} style={{ alignItems: 'center', alignContent: 'center' }}>
              <p>Entre também como:</p>
            </Form.Item>
            <Form.Item {...tailLayout} style={{ alignItems: 'center', alignContent: 'center' }}>
              <Row>
                <Col style={{ padding: 10 }} span={12}>
                  <Button shape="round" onClick={() => ePrescriptionModo()} style={{ width: 100, backgroundColor: '#168e6d', borderColor: '#168e6d' }} type="primary" htmlType="submit">
                    Médicos
                  </Button>
                </Col>
                <Col style={{ padding: 10 }} span={12}>
                  <Button shape="round" style={{ width: 100, backgroundColor: '#168e6d', borderColor: '#168e6d' }} type="primary" htmlType="submit">
                    Clínicas
                  </Button>
                </Col>
              </Row>
            </Form.Item>

          </Form>
        </Col>
      </Row>
    </Content>


  );
}

const mapState = (state) => ({
  usuario: state.usuario.usuario,
})
const mapDispatch = (dispatch) => ({
  definirUsuario: dispatch.usuario.definirUsuario,
  asyncLogin: payload => dispatch.usuario.asyncLogin(payload),
})

export default connect(mapState, mapDispatch)(App)
